import React, { useState, useEffect } from "react";
import "./Forms.css";
import { Modal } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";
import { Col, Row, Button, Spinner } from "react-bootstrap";
import Heading from "../Heading/Heading";
import NavigationButtons from "../Navigation Buttons/Navigation Buttons";
import ConfirmationModal from "../Confirmation Modal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card } from "react-bootstrap";

import { getForms_PDF_URL__API } from "../../api";
import Loader from "../Loader/Loader";
import TabsComponent from "../Common Modules/TabsComponent";
import { DocumentDownloadList } from "./DocumentDownloadList";

const Forms = ({ onLogout }) => {
  const userID = localStorage.getItem("userId");


  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [logoutClicked, setLogoutClicked] = useState(false);
  const [showConfirmationModalForLogout, setShowConfirmationModalForLogout] = useState(false);
  const [showConfirmationBackModal, setShowConfirmationBackModal] = useState(false);
  const [backButtonClicked, setBackButtonClicked] = useState(false);

  const [forms, setForms] = useState([]);

  const handleConfirmationBackNo = () => {
    setShowConfirmationBackModal(false);
  };

  const handleConfirmationBackYes = () => {
    navigate("/user/dashboard");
    setShowConfirmationBackModal(false);
    toast.success("Navigated to Dashboard.");
  };

  const handleBack = () => {
    // setBackButtonClicked(true);
    // setShowConfirmationBackModal(true);

    navigate("/user/dashboard");


  };

  const handleUpdatePersonalDetails = () => {
    navigate("/user/update_profile");
  };

  const handleLogout = () => {
    setShowConfirmationModalForLogout(true);
    setLogoutClicked(true);
  };

  const handleConfirmationLogoutYes = () => {
    localStorage.clear();
    onLogout();
    navigate("/");
    toast.success("Logged out successfully!");
  };

  const handleConfirmationLogoutNo = () => {
    setShowConfirmationModalForLogout(false);
    setLogoutClicked(false);
  };

  useEffect(() => {
    handleShowModal();
  }, []);

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirm = () => {
    handleCloseModal();
  };


  const getFormsPDFDetailsFunction = async () => {
    const formData = new FormData();
    formData.append("user_id", userID);

    try {
      setLoading(true);

      const response = await getForms_PDF_URL__API(formData);

      setLoading(false);

      if (response?.data?.response?.response === true) {
        const formDetails = response?.data?.response?.data || [];
        setForms(formDetails);
        console.log("Forms PDF Details:", forms.forms_and_checklists);
      } else {
        toast.error(response?.data?.response?.error_msg || "Failed to get Forms to download");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Failed to get Forms to download");
    }
  };

  useEffect(() => {
    if (userID && !showModal) {
      getFormsPDFDetailsFunction();
    }
  }, [userID, showModal]);


  // Filter out Stage-2 Checklist from Forms & Checklists tab
  const formsAndChecklistsFiltered = (forms?.forms_and_checklists || []).filter(
    (doc) => {
      const name = (doc?.name || "").toLowerCase();
      return !(name.includes("stage") && name.includes("2") && name.includes("checklist"));
    }
  );

  // Prepare tab data after forms are loaded
  const tabsData = [
    {
      key: "forms",
      title: "Forms & Checklists",
      content: (
        <DocumentDownloadList
          data_documents={formsAndChecklistsFiltered}
          occupationColumn={false}
        />
      ),
    },
    {
      key: "saq",
      title: "SAQ's",
      content: (
        <DocumentDownloadList
          data_documents={forms?.saq_files || []}
          occupationColumn={true}
        />
      ),
    },
    {
      key: "kits",
      title: "Applicant Kits",
      content: (
        <DocumentDownloadList
          data_documents={forms?.application_kit_files || []}
          occupationColumn={true}
        />
      ),
    },
    {
      key: "rpl_saq",
      title: "RPL Declaration & SAQ",
      content: (
        <DocumentDownloadList
          data_documents={forms?.rpl_saq_files || []}
          occupationColumn={true}
        />
      ),
    },
    {
      key: "supporting_evidence_checklist",
      title: "Supporting Evidence Checklist",
      content: (
        <DocumentDownloadList
          data_documents={forms?.supporting_evidence_checklist_files || []}
          occupationColumn={true}
        />
      ),
    },
    {
      key: "third_part",
      title: "Third Party Reports",
      content: (
        <DocumentDownloadList
          data_documents={forms?.third_party_files || []}
          occupationColumn={true}
        />
      ),
    }
  ];

  return (
    <>
      <Row>
        <Col>
          <Button
            className="back-button"
            variant=""
            onClick={handleBack}
            style={{ color: "#055837", marginLeft: "25px", outline: "none", boxShadow: "none" }}
          >
            <BsArrowLeft className="me-0" />
            Back to Dashboard
          </Button>
        </Col>

        <Col>
          <NavigationButtons
            handleUpdatePersonalDetails={handleUpdatePersonalDetails}
            handleLogout={handleLogout}
          />
        </Col>
        <Heading text="Application Support Files" />
      </Row>
      <div className="container my-5 shadow-lg p-0">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center p-5">
            <Spinner animation="border" style={{ color: "#055837" }} />
          </div>
        ) : forms && Object.keys(forms).length > 0 ? (
          <TabsComponent tabs={tabsData} defaultKey="forms" />
        ) : (
          <div className="text-center p-5" style={{ color: "#055837" }}>
            No forms available.
          </div>
        )}
      </div>


      <div className="forgot-container-identification">

        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header>
            <Modal.Title
              className="text-center"
              style={{
                fontSize: "18px",
                fontFamily: "Arial, sans-serif",
                color: "#055837",
              }}
            >
              {"Note :-"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            className="text-center"
            style={{ fontSize: "16px", fontFamily: "Arial, sans-serif" }}
          >
            {
              "These documents are there for your convenience in case they are required after the application lodgement. We encourage you to download & use the forms generated while creating a new application."
            }
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="light"
              onClick={handleConfirm}
              className="w-50"
              style={{
                maxWidth: "80px",
                backgroundColor: "#ffcc01",
                color: "#055837",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#055837";
                e.target.style.color = "#ffcc01";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#ffcc01";
                e.target.style.color = "#055837";
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        {backButtonClicked && (
          <ConfirmationModal
            show={showConfirmationBackModal}
            onHide={handleConfirmationBackNo}
            onConfirm={handleConfirmationBackYes}
            title="Confirm Navigation"
            message="Are you sure you want to go back to the Dashboard page?"
          />
        )}

        {logoutClicked && (
          <ConfirmationModal
            show={showConfirmationModalForLogout}
            onHide={handleConfirmationLogoutNo}
            onConfirm={handleConfirmationLogoutYes}
            title="Confirm Logout"
            message="Are you sure you want to log out?"
          />
        )}
      </div>
    </>
  );
};

export default Forms;
